export const ActionTypes = {
    FETCH_PRODUCTS_REQUEST: "FETCH_PRODUCTS_REQUEST",
    FETCH_PRODUCTS_SUCCESS: "FETCH_PRODUCTS_SUCCESS",
    FETCH_SINGLE_PRODUCT_SUCCESS: "FETCH_SINGLE_PRODUCT_SUCCESS",
    FETCH_SINGLE_PRODUCT_REQUEST: "FETCH_SINGLE_PRODUCT_REQUEST",
    FETCH_SINGLE_PRODUCT_FAILURE: "FETCH_SINGLE_PRODUCT_FAILURE",
    FETCH_PRODUCTS_FAILURE: "FETCH_PRODUCTS_FAILURE",
};
